
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="实例方法" fileName="instance-methods.md" />
        <demo-block>
        <div><p>1、通过实例方法 <code>hideColumnsByKeys(keys)</code>将列隐藏 <br>2、通过实例方法 <code>showColumnsByKeys(keys)</code>将隐藏的列显示</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;hideColumns(['col1'])&quot;&gt;隐藏 col1 列&lt;/button&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;hideColumns(['col2'])&quot;&gt;隐藏 col2 列&lt;/button&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;hideColumns(['col3'])&quot;&gt;隐藏 col3 列&lt;/button&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;hideColumns(['col1','col2','col3'])&quot;&gt;
            隐藏 col1、col2、col3 列
        &lt;/button&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;showColumns(['col1'])&quot;&gt;显示 col1 列&lt;/button&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;showColumns(['col2'])&quot;&gt;显示 col2 列&lt;/button&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;showColumns(['col3'])&quot;&gt;显示 col3 列&lt;/button&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;showColumns(['col1','col2','col3'])&quot;&gt;
            显示 col1、col2、col3 列
        &lt;/button&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;ve-table
            ref=&quot;tableRef&quot;
            border-y
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            :columnHiddenOption=&quot;columnHiddenOption&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                columnHiddenOption: {
                    // default hidden column keys
                    defaultHiddenColumnKeys: [&quot;col8&quot;],
                },
                columns: [
                    { field: &quot;col1&quot;, key: &quot;col1&quot;, title: &quot;col1&quot;, width: &quot;10%&quot; },
                    {
                        title: &quot;col2-col3&quot;,
                        children: [
                            {
                                field: &quot;col2&quot;,
                                key: &quot;col2&quot;,
                                title: &quot;col2&quot;,
                                width: 100,
                            },
                            {
                                field: &quot;col3&quot;,
                                key: &quot;col3&quot;,
                                title: &quot;col3&quot;,
                                width: 110,
                            },
                        ],
                    },
                    {
                        title: &quot;col4-col5-col6&quot;,
                        children: [
                            {
                                title: &quot;col4-col5&quot;,
                                children: [
                                    {
                                        field: &quot;col4&quot;,
                                        key: &quot;col4&quot;,
                                        title: &quot;col4&quot;,
                                        width: 130,
                                    },
                                    {
                                        field: &quot;col5&quot;,
                                        key: &quot;col5&quot;,
                                        title: &quot;col5&quot;,
                                        width: 140,
                                    },
                                ],
                            },
                            {
                                title: &quot;col6&quot;,
                                field: &quot;col6&quot;,
                                key: &quot;col6&quot;,
                                width: 140,
                            },
                        ],
                    },
                    { field: &quot;col7&quot;, key: &quot;col7&quot;, title: &quot;col7&quot;, width: 150 },
                    { field: &quot;col8&quot;, key: &quot;col8&quot;, title: &quot;col8&quot;, width: 160 },
                ],
                tableData: [],
            };
        },
        methods: {
            // hidden columns
            hideColumns(keys) {
                this.$refs[&quot;tableRef&quot;].hideColumnsByKeys(keys);
            },
            // show cloumns
            showColumns(keys) {
                this.$refs[&quot;tableRef&quot;].showColumnsByKeys(keys);
            },
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 3; i++) {
                    data.push({
                        rowKey: i,
                        col1: &quot;col1-&quot; + i,
                        col2: &quot;col2-&quot; + i,
                        col3: &quot;col3-&quot; + i,
                        col4: &quot;col4-&quot; + i,
                        col5: &quot;col5-&quot; + i,
                        col6: &quot;col6-&quot; + i,
                        col7: &quot;col7-&quot; + i,
                        col8: &quot;col8-&quot; + i,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.hideColumns(['col1'])}}},[_vm._v("隐藏 col1 列")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.hideColumns(['col2'])}}},[_vm._v("隐藏 col2 列")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.hideColumns(['col3'])}}},[_vm._v("隐藏 col3 列")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.hideColumns(['col1','col2','col3'])}}},[_vm._v("\n            隐藏 col1、col2、col3 列\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.showColumns(['col1'])}}},[_vm._v("显示 col1 列")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.showColumns(['col2'])}}},[_vm._v("显示 col2 列")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.showColumns(['col3'])}}},[_vm._v("显示 col3 列")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.showColumns(['col1','col2','col3'])}}},[_vm._v("\n            显示 col1、col2、col3 列\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ve-table',{ref:"tableRef",attrs:{"border-y":"","columns":_vm.columns,"table-data":_vm.tableData,"columnHiddenOption":_vm.columnHiddenOption}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                columnHiddenOption: {
                    // default hidden column keys
                    defaultHiddenColumnKeys: ["col8"],
                },
                columns: [
                    { field: "col1", key: "col1", title: "col1", width: "10%" },
                    {
                        title: "col2-col3",
                        children: [
                            {
                                field: "col2",
                                key: "col2",
                                title: "col2",
                                width: 100,
                            },
                            {
                                field: "col3",
                                key: "col3",
                                title: "col3",
                                width: 110,
                            },
                        ],
                    },
                    {
                        title: "col4-col5-col6",
                        children: [
                            {
                                title: "col4-col5",
                                children: [
                                    {
                                        field: "col4",
                                        key: "col4",
                                        title: "col4",
                                        width: 130,
                                    },
                                    {
                                        field: "col5",
                                        key: "col5",
                                        title: "col5",
                                        width: 140,
                                    },
                                ],
                            },
                            {
                                title: "col6",
                                field: "col6",
                                key: "col6",
                                width: 140,
                            },
                        ],
                    },
                    { field: "col7", key: "col7", title: "col7", width: 150 },
                    { field: "col8", key: "col8", title: "col8", width: 160 },
                ],
                tableData: [],
            };
        },
        methods: {
            // hidden columns
            hideColumns(keys) {
                this.$refs["tableRef"].hideColumnsByKeys(keys);
            },
            // show cloumns
            showColumns(keys) {
                this.$refs["tableRef"].showColumnsByKeys(keys);
            },
            initTableData() {
                let data = [];
                for (let i = 0; i < 3; i++) {
                    data.push({
                        rowKey: i,
                        col1: "col1-" + i,
                        col2: "col2-" + i,
                        col3: "col3-" + i,
                        col4: "col4-" + i,
                        col5: "col5-" + i,
                        col6: "col6-" + i,
                        col7: "col7-" + i,
                        col8: "col8-" + i,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  